import ValueObject from 'src/app/core/domain/value_object';

import { Tracker } from '../tracker/tracker';
import { TrackerType } from '../tracker/tracker_type';

interface DiaryTrackerProps {
  name: string;
  type: TrackerType;
  min?: number;
  max: number;
  value: number;
  steps?: number;
}

export class DiaryTracker extends ValueObject<DiaryTrackerProps> {
  active?: boolean;

  get name(): string {
    return this.props.name;
  }

  get min(): number | undefined {
    return this.props.min;
  }

  get max(): number {
    return this.props.max;
  }

  get value(): number {
    return this.props.value;
  }

  set value(v: number) {
    this.props.value = v;
  }

  get type(): TrackerType {
    return this.props.type;
  }

  get steps(): number | undefined {
    return this.props.steps;
  }

  set steps(value: number | undefined) {
    this.props.steps = value;
  }

  private constructor(props: DiaryTrackerProps) {
    super(props);
  }

  public static doCalculateSteps(tracker: DiaryTracker | Tracker) {
    if (
      tracker.type != null &&
      tracker.max != null &&
      tracker.max! > (tracker.min ?? 0)
    ) {
      switch (tracker.type) {
        case TrackerType.Note:
          return tracker.max - (tracker.min ?? 0);
        case TrackerType.Number:
          if (tracker.max % 60 == 0) {
            return (tracker.max - (tracker.min ?? 0)) / 5;
          } else {
            return tracker.max > 50
              ? (tracker.max - (tracker.min ?? 0)) / 10
              : tracker.max - (tracker.min ?? 0);
          }
        case TrackerType.Percent:
          if ((tracker.max - (tracker.min ?? 0)) % 10 == 0) {
            return (tracker.max - (tracker.min ?? 0)) / 10;
          } else if ((tracker.max - (tracker.min ?? 0)) % 5 == 0) {
            return (tracker.max - (tracker.min ?? 0)) / 5;
          } else if ((tracker.max - (tracker.min ?? 0)) % 2 == 0) {
            return (tracker.max - (tracker.min ?? 0)) / 2;
          } else {
            return tracker.max - (tracker.min ?? 0);
          }
      }
    }
    return 10;
  }

  public static create(props: DiaryTrackerProps): DiaryTracker {
    const d = new DiaryTracker(props);
    d.active =
      d.value !== (d.min ?? 0) - d.max / DiaryTracker.doCalculateSteps(d);
    return d;
  }
}
